import {createContext} from "react";
import {AlertContextValue} from "./AlertContextValue";

export const AlertContext = createContext<AlertContextValue>([
  undefined,
  () => {},
  () => {}
]);
